<div mat-dialog-title>
  <h1 class="titulo-simpli">{{ title }}</h1>
  <small class="subtitulo-simpli"></small>
</div>
<div mat-dialog-content>
  <div [ngClass]="{'success-icon': true, 'error': isError}">
    <mat-icon>{{ icon }}</mat-icon>
  </div>
  <div class="dialog-content">{{ message }}</div>
</div>
<div mat-dialog-actions>
  <button class="secondary-button" mat-stroked-button color="primary" (click)="closeDialog()">{{ buttonText }}</button>
</div>